import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

import { useDecodedToken } from "../Services/Routes/APP/PrivateRoute";
import { domain } from "../Services/Routes/API";
import { headersGet } from "../Services/API";

const Logo = ({ width, height }) => {
	const user = useDecodedToken();
	const [logoUrl, setLogoUrl] = useState(null);

	useEffect(() => {
		const LOGO_URL = user?.logo?.url;
		if (LOGO_URL) {
			const IMAGE_URL = domain + LOGO_URL;
			headersGet(IMAGE_URL)
				.then((response) => {
					if (response?.status === 200) {
						setLogoUrl(IMAGE_URL);
					} else {
						setLogoUrl(null);
					}
				})
				.catch(() => {
					setLogoUrl(null);
				});
		} else {
			setLogoUrl(null);
		}
	}, []);

	return logoUrl ? (
		<Box
			sx={{
				margin: "auto",
				marginTop: "1rem",
				height: "8rem",
				width: "8rem",
				maxHeight: "8rem",
				maxWidth: "8rem",
			}}
		>
			<Box
				component="img"
				sx={{
					height: height || "100%",
					width: width || "100%",
					borderRadius: "50%",
				}}
				alt="Ministry Logo"
				src={logoUrl}
				onError={() => {
					setLogoUrl(null);
				}}
			/>
		</Box>
	) : (
		<svg
			width={width || 110}
			height={height || 80}
			viewBox="0 0 282 322"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M152.01 191.84L236.02 275.85"
				stroke="#231F20"
				strokeWidth="4"
				strokeMiterlimit="10"
			/>
			<path
				d="M136.77 201.19L52.7598 285.2"
				stroke="#231F20"
				strokeWidth="4"
				strokeMiterlimit="10"
			/>
			<path
				d="M149.49 54.1699V99.9999"
				stroke="#231F20"
				strokeWidth="5"
				strokeMiterlimit="10"
			/>
			<path
				d="M143.61 94.9398L195.36 79.2798L166.72 129.49C166.574 129.747 166.505 130.04 166.52 130.335C166.535 130.629 166.634 130.914 166.805 131.155C166.976 131.395 167.213 131.582 167.486 131.693C167.76 131.803 168.06 131.834 168.35 131.78L203.54 125.24L107.87 287.62L134.48 194.31C134.564 194.021 134.561 193.714 134.473 193.427C134.384 193.14 134.213 192.885 133.982 192.694C133.75 192.502 133.467 192.383 133.168 192.35C132.87 192.318 132.568 192.373 132.3 192.51L112.3 202.51L143.61 94.9398Z"
				fill="#E9262B"
				stroke="#231F20"
				strokeWidth="3"
				strokeMiterlimit="10"
			/>
			<path
				d="M150.43 62.6C167.164 62.6 180.73 49.0342 180.73 32.3C180.73 15.5658 167.164 2 150.43 2C133.696 2 120.13 15.5658 120.13 32.3C120.13 49.0342 133.696 62.6 150.43 62.6Z"
				fill="#77C044"
				stroke="#231F20"
				strokeWidth="3"
				strokeMiterlimit="10"
			/>
			<path
				d="M249.7 320.1C266.435 320.1 280 306.534 280 289.8C280 273.066 266.435 259.5 249.7 259.5C232.966 259.5 219.4 273.066 219.4 289.8C219.4 306.534 232.966 320.1 249.7 320.1Z"
				fill="#FBB316"
				stroke="#231F20"
				strokeWidth="3"
				strokeMiterlimit="10"
			/>
			<path
				d="M32.3 320.1C49.0342 320.1 62.6 306.534 62.6 289.8C62.6 273.066 49.0342 259.5 32.3 259.5C15.5658 259.5 2 273.066 2 289.8C2 306.534 15.5658 320.1 32.3 320.1Z"
				fill="#37A6DE"
				stroke="#231F20"
				strokeWidth="3"
				strokeMiterlimit="10"
			/>
		</svg>
	);
};

export default Logo;
